import noodleApiClient, { ApiDefinition } from '@noodleApi';

type ThisApi = ApiDefinition['/companies/:creatorId/:companyId']['PUT'];

type Input = ThisApi['body'] & { creatorId: string; companyId: string };

type Output = ThisApi['response'];

const updateCompany = async ({ creatorId, companyId, name, email, phoneNumber, pointOfContact }: Input): Promise<Output> => {
  const response = await noodleApiClient.put(`/companies/${creatorId}/${companyId}`, {
    email,
    name,
    phoneNumber,
    pointOfContact,
  });

  return response.data;
};

export default updateCompany;
